/* eslint-disable react/static-property-placement */
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { map } from 'lodash';

function getValue(value) {
  if (typeof value === 'object' && value !== null) {
    const orderedValue = {};
    Object.keys(value)
      .sort()
      .forEach((key) => {
        orderedValue[key] = value[key];
      });
    return JSON.stringify(orderedValue);
  }

  return value;
}

function parse(event) {
  const { value } = event.target;

  try {
    return JSON.parse(value);
  } catch (e) {
    return value;
  }
}

/** @deprecated */
export default class Select extends PureComponent {
  static propTypes = {
    id: PropTypes.string,
    value: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
      PropTypes.object,
      PropTypes.array,
    ]),
    options: PropTypes.arrayOf(PropTypes.object).isRequired,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    valueField: PropTypes.string,
    textField: PropTypes.string,
    isDisabledField: PropTypes.string,
    placeholder: PropTypes.string,
    defaultValue: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
      PropTypes.object,
      PropTypes.array,
    ]),
  };

  static defaultProps = {
    id: '1',
    value: '',
    onBlur: () => {},
    onChange: () => {},
    valueField: undefined,
    textField: undefined,
    isDisabledField: '',
    placeholder: '',
    defaultValue: '',
  };

  render() {
    const {
      value,
      defaultValue,
      options,
      onBlur,
      onChange,
      valueField,
      textField,
      isDisabledField,
      placeholder,
      ...rest
    } = this.props;

    if (!onChange) {
      rest.defaultValue = getValue(defaultValue);
    } else {
      rest.value = getValue(value);
      rest.onChange = (e) => onChange(parse(e));
    }

    return (
      <select
        id="one"
        {...rest}
        onBlur={(e) => onBlur(parse(e))}
        className="form-control border border-solid border-gray-500 bg-white w-full"
      >
        {placeholder && <option value="">{placeholder}</option>}
        {map(options, (option, index) => {
          let optionValue;
          if (valueField) {
            optionValue = option[valueField];
          } else if (typeof option !== 'string') {
            optionValue = JSON.stringify(option);
          } else {
            optionValue = option;
          }
          const optionLabel = textField ? option[textField] : option;
          return (
            <option
              value={optionValue}
              disabled={option[isDisabledField]}
              key={index}
            >
              {optionLabel}
            </option>
          );
        })}
      </select>
    );
  }
}
